/*!
 * Copyright (c) 2017-present Cliqz GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* tslint:disable quotemark */
export default [
  "securepubads.g.doubleclick.net",
  "googlesyndication",
  "imasdk.googleapis",
  "googletagmanager",
  ".cloudfront.net",
  ".actonservice",
  "marketing.",
  "analytics",
  "smetrics.",
  "tracking.",
  ".website",
  "metrics.",
  "images.",
  "plausib",
  ".co.uk",
  "a8clk.",
  "stats.",
  "a8cv.",
  "media",
  "track",
  ".com",
  ".net",
  ".xyz",
  "www.",
  ".de",
  ".io",
  ".jp",
  "a8.",
  "aff",
  "app",
  "cdn",
  "ght",
  "new",
  "pro",
  "web",
  ".b",
  ".c",
  ".d",
  ".e",
  ".f",
  ".h",
  ".k",
  ".m",
  ".n",
  ".p",
  ".s",
  ".t",
  ".w",
  "10",
  "24",
  "a1",
  "ab",
  "ac",
  "ad",
  "af",
  "ag",
  "ah",
  "ai",
  "ak",
  "al",
  "am",
  "an",
  "ap",
  "ar",
  "as",
  "at",
  "au",
  "av",
  "aw",
  "ay",
  "az",
  "be",
  "bi",
  "bl",
  "bo",
  "br",
  "bu",
  "ca",
  "ce",
  "ch",
  "ci",
  "ck",
  "cl",
  "cr",
  "ct",
  "cu",
  "da",
  "de",
  "di",
  "do",
  "dr",
  "ds",
  "du",
  "dy",
  "e-",
  "eb",
  "ec",
  "ed",
  "ef",
  "el",
  "em",
  "en",
  "ep",
  "er",
  "es",
  "et",
  "ev",
  "ew",
  "ex",
  "fa",
  "fe",
  "ff",
  "fi",
  "fo",
  "fr",
  "ge",
  "gi",
  "go",
  "gr",
  "gu",
  "he",
  "ho",
  "ia",
  "ic",
  "id",
  "if",
  "ig",
  "ik",
  "il",
  "im",
  "in",
  "ip",
  "ir",
  "is",
  "it",
  "iv",
  "ix",
  "iz",
  "jo",
  "ke",
  "ki",
  "ks",
  "la",
  "ld",
  "le",
  "li",
  "ll",
  "lo",
  "lu",
  "ly",
  "ma",
  "me",
  "mo",
  "mp",
  "my",
  "ne",
  "no",
  "ol",
  "om",
  "on",
  "oo",
  "op",
  "or",
  "ot",
  "ou",
  "pe",
  "ph",
  "pl",
  "po",
  "pr",
  "pu",
  "qu",
  "re",
  "ri",
  "ro",
  "ru",
  "s-",
  "sc",
  "se",
  "sh",
  "si",
  "sk",
  "sm",
  "so",
  "sp",
  "ss",
  "st",
  "su",
  "sw",
  "sy",
  "t-",
  "ta",
  "te",
  "th",
  "ti",
  "tn",
  "to",
  "tr",
  "ts",
  "tt",
  "tu",
  "ty",
  "ub",
  "ul",
  "um",
  "un",
  "up",
  "ur",
  "us",
  "ut",
  "ve",
  "vi",
  "vo",
  "we",
  "wh",
  "wn",
  "-",
  ".",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
];